import { Injectable, inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { PortalSessionMarker } from './portal-session-marker';
import { discardTokens, ownsPortalSession } from './session-ownership';

/** Validity of the Shell authentication, checked on every guarded navigation. */
@Injectable({ providedIn: 'root' })
export class PortalSession {
  private readonly oktaAuth = inject(OKTA_AUTH);

  /** True when the Shell holds tokens of the portal session user. Orphaned tokens are discarded. */
  async isValid(): Promise<boolean> {
    if (!(await this.oktaAuth.isAuthenticated())) {
      return false;
    }
    if (ownsPortalSession(this.oktaAuth)) {
      return true;
    }
    await discardTokens(this.oktaAuth);
    return false;
  }

  /** A portal user is signed in (possibly in Legacy), so the Shell can obtain its tokens silently. */
  hasActiveSession(): boolean {
    return PortalSessionMarker.read() !== null;
  }
}
